import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Used to store global event callback context.
 */
export const GlobalEventCallbackContext = React.createContext({
  signOutCallback: null,
  setSignOutCallback: _.noop,
});

export function GlobalEventCallbackContextProvider(props) {
  const { children } = props;
  const [signOutCallback, setSignOutCallback] = useState(null);

  return (
    <GlobalEventCallbackContext.Provider value={{
      signOutCallback,
      setSignOutCallback,
    }}
    >
      {children}
    </GlobalEventCallbackContext.Provider>
  );
}

GlobalEventCallbackContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
